import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectOfferId } from '../../../../selectors/offerData';
import { trackOfferClick } from '../analytics';

export const useHandleOfferClick = () => {
  const offerId = useSelector(selectOfferId);

  return React.useCallback((clickedOfferId: number) => trackOfferClick(offerId, clickedOfferId), [offerId]);
};
